<template>
  <sc-card
    class="page-logs-tracking-event-header-lote"
    v-if="showBox">
    <template slot="header">
      <h2 class="has-text-primary is-size-4 card-header-title">Lote</h2>
    </template>

    <template slot="body">
      <p
        class="heading"
        v-if="event.hash">
        <strong>Nome do lote:</strong>
      </p>

      <sc-tooltip label="Visualizar o lote">
        <router-link
        class="hash"
          :to="{
            name: 'logs-tracking-lote',
            params: {
              id: event.hash,
            },
          }">
          {{ event.hash }}
        </router-link>
      </sc-tooltip>

      <p
        class="heading"
        v-if="getLogisticProviderName(event.logistic_provider_id)">
        <strong>Transportadora:</strong>
        <span>{{ getLogisticProviderName(event.logistic_provider_id) }}</span>
      </p>

      <p
        class="heading"
        v-if="event.origin">
        <strong>Origem:</strong>
        <span>{{ event.origin }}</span>
      </p>
    </template>
  </sc-card>
</template>

<script>
  import { ScCard, ScTooltip } from '@intelipost-js/secure-components';
  import { createNamespacedHelpers } from 'vuex';

  const { mapState } = createNamespacedHelpers('analytic/logsTracking');

  export default {
    name: 'sc-logs-tracking-detail-header-lote',
    computed: {
      ...mapState([
        'event',
      ]),
      showBox() {
        return !!this.event && (
          !!this.event.hash ||
          !!this.event.origin ||
          !!this.getLogisticProviderName(this.event.logistic_provider_id));
      },
    },
    methods: {
      getLogisticProviderName(logisticProviderId) {
        return this.$store.getters['logisticProviders/logisticProviderName'](logisticProviderId);
      },
    },
    beforeMount() {
      return this.$store.dispatch('logisticProviders/getLogisticProviders');
    },
    components: {
      ScCard,
      ScTooltip,
    },
  };
</script>

<style lang="scss" scoped>
  .page-logs-tracking-event-header-lote {
    height: 100%;
  }
  .hash {
    word-break: break-word;
  }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/logs/pages/tracking/pages/logs-tracking-detail/components/sc-logs-tracking-detail-header/blocks/sc-logs-tracking-detail-header-lote/ScLogsTrackingDetailHeaderLote.vue?c2741be4